import type {
  RestaurantAttendance,
  TypePlanActionPoiStatusSet
} from "./PlansReducer"
import config from "../../config"
import WS from "../../utils/ws"

const actions = {
  fetchStatuses: (): Promise<TypePlanActionPoiStatusSet> => {
    return new WS(config.WS_PREFIX + config.webservices.poi.status)
      .get()
      .execute()
      .then(response => ({
        type: "PLAN_POI_SET",
        payload: response.pois
      }))
  },
  fetchRestaurantAttendance: (): Promise<RestaurantAttendance> => {
    return new WS(config.WS_PREFIX + config.webservices.restaurant.attendance)
      .get()
      .execute()
      .then(response => ({
        type: "RESTAURANT_ATTENDANCE_SET",
        payload: response
      }))
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/plans/PlansActions.js